import { render } from "./UnidadMedidaCreate.vue?vue&type=template&id=d9ddef2a&scoped=true"
import script from "./UnidadMedidaCreate.vue?vue&type=script&lang=js"
export * from "./UnidadMedidaCreate.vue?vue&type=script&lang=js"

import "./UnidadMedidaCreate.vue?vue&type=style&index=0&id=d9ddef2a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ddef2a"]])

export default __exports__